import { ErrorMessage, UiMessageKey } from '@bechtel/sr-types';
import { QuestionModalResponse } from './question-modal';
export enum MessageType {
  ERROR,
  INFO,
  QUESTION,
}

export interface MessageModalProps {
  messageKeys: ErrorMessage[] | UiMessageKey[];
  onSubmit?: (response: QuestionModalResponse[]) => Promise<void>;
  onClose?: () => void;
  dismissIndex?: number; //Question index to close modal on pressing No, starting from 0
}
export interface BulkMessageItem {
  tag: string;
  messageKeys: ErrorMessage[] | UiMessageKey[];
}

export interface BulkMessageModalProps {
  messages: BulkMessageItem[];
}
